import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import CitationCell from '@Components/Results/substances/tables/cells/citation-cell.component';
import DataCell from '@Components/Results/substances/tables/cells/data-cell.component';
import NumberFormatter from '@Utils/NumberFormatter';
import { CITATION_LINKS_TRACKING_INDEX_MARKER } from '@Components/Results/analytics/citationLinksTracking';

function renderCell(cell, metadata) {
  if (cell.id !== 'citation') {
    return <DataCell data={cell.value} />;
  }
  return <CitationCell metadata={metadata} citations={cell.value} />;
}

export default class SubstanceQuantitativeReport extends React.PureComponent {
  render() {
    const { metadata, data, total } = this.props;

    return (
      <div className="quantitative-information">
        {data.map((report, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={index} className="quantitative-information__item">
            <div className="quantitative-information__count">
              {NumberFormatter(index + 1, 0)} of {NumberFormatter(total, 0)}
            </div>

            {report.length > 0 && (
              <table className="rx-table rx-table--full-width quantitative-information__table">
                <tbody>
                  {report.map(
                    // eslint-disable-next-line no-shadow
                    (item, index) =>
                      item.field.value &&
                      item.field.value?.length > 0 && (
                        // eslint-disable-next-line react/no-array-index-key
                        <tr key={index} {...CITATION_LINKS_TRACKING_INDEX_MARKER.substancesTableItem}>
                          <InnerHTML tag="th" scope="row" html={item.header?.title} />

                          <td>{renderCell(item.field, metadata)}</td>
                        </tr>
                      )
                  )}
                </tbody>
              </table>
            )}
          </div>
        ))}
      </div>
    );
  }
}

SubstanceQuantitativeReport.propTypes = {
  metadata: MetadataPropTypesShape,
  data: PropTypes.object.isRequired,
  total: PropTypes.number.isRequired,
};
